module.exports = __webpack_public_path__ + "img/mating.17424e0.png";